import {Choice, FilterOptionOption, OptionTypeBase} from 'platform/components';
import {match} from 'ts-pattern';

import {i18n} from '@dms/i18n';

import {Nullish, suffixTestId, TestIdProps} from 'shared/web';

import {useMakeModelFilter} from '../../../../../hooks/useMakeModelFilter';
import {getOptionType} from '../../../../../utils/getOptionType';
import {getHighlightedText} from '../utils/getHighlightedText';

const toOptions = (items: Record<string, {label: string}> | Nullish) =>
  Object.entries(items ?? {}).map(([key, value]) => ({...value, value: key}));

export function MakesModelsSearch(props: TestIdProps) {
  const {models, modelFamilies, makes, selectMakeModel} = useMakeModelFilter();

  // A model family and its model often share a name (Iveco Daily, Audi A4), so the options are
  // split into sections that say what each one selects.
  const options = [
    {label: i18n.t('page.filters.labels.makes'), options: toOptions(makes)},
    {label: i18n.t('page.filters.labels.modelFamilies'), options: toOptions(modelFamilies)},
    {label: i18n.t('page.filters.labels.models'), options: toOptions(models)},
  ];

  const filterOption = (
    option: FilterOptionOption<OptionTypeBase<string | Nullish>>,
    inputValue: string
  ) =>
    match<[number, 'make' | 'modelFamily' | 'model']>([
      inputValue.length,
      getOptionType(option.value),
    ])
      .with([0, 'make'], () => true)
      .with([0, 'modelFamily'], () => false)
      .with([1, 'modelFamily'], () => false)
      .with([0, 'model'], () => false)
      .with([1, 'model'], () => false)
      .with([2, 'model'], () => false)
      .otherwise(() => option.label.toLowerCase().includes(inputValue.toLowerCase()));

  return (
    <Choice
      value={null}
      onChange={selectMakeModel}
      options={options}
      filterOption={filterOption}
      formatOptionLabel={(option, {context, inputValue}) =>
        context === 'menu' && inputValue.length > 0
          ? getHighlightedText(option.label ?? '', inputValue)
          : option.label
      }
      placeholder={i18n.t('general.labels.searchFor')}
      data-testid={suffixTestId('search', props)}
    />
  );
}
